import { UitkPageLoader } from 'uitk-react-loader'

export default UitkPageLoader
